<template>
  <icon class="spinner" name="fa-spinner" />
</template>
<style lang="scss" scoped>
.spinner {
  display: inline-block;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>